import {getErrorMessage, noop} from '@yandex-delivery/utils'
import clsx from 'clsx'
import React, {useCallback, useState} from 'react'
import {createPortal} from 'react-dom'

import {classes} from './classes'
import {NotificationsProvider} from './context'
import {Notification} from './Notification'
import {AddNotification, CustomNotification} from './types'
import {Translator} from '@yandex-delivery/core/i18n'

let id = 0

export const Notifications: React.FC<
  React.PropsWithChildren<{className?: string; isNotificationsDisabled?: boolean; i18n?: Translator}>
> = ({children, className, isNotificationsDisabled, i18n}) => {
  const [notifications, setNotifications] = useState<CustomNotification[]>([])

  const removeNotification = useCallback((itemId: CustomNotification['id']) => {
    setNotifications(list => list.filter(({id}) => id !== itemId))
  }, [])

  const addNotification = useCallback<AddNotification>((msg, notificationConfig) => {
    const message = msg instanceof Error ? getErrorMessage(msg) : msg
    const type = msg instanceof Error ? 'error' : notificationConfig?.type
    const newNotification: CustomNotification = {
      ...notificationConfig,
      type: type || 'success',
      msg: message,
      id: ++id,
    }

    setNotifications(old => [...old, newNotification])
  }, [])

  return (
    <NotificationsProvider value={isNotificationsDisabled ? noop : addNotification}>
      {children}
      {typeof document !== 'undefined'
        ? createPortal(
            <ul className={clsx(classes.notificationsContainer, className)}>
              {notifications.map(item => (
                <Notification i18n={i18n} key={String(item.id)} remove={() => removeNotification(item.id)} {...item} />
              ))}
            </ul>,
            document.body,
          )
        : null}
    </NotificationsProvider>
  )
}
